import React, { useState, useEffect, useRef } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

// Se sirve desde un CDN en vez de empaquetarlo con nuestro propio build:
// en celulares reales (a diferencia de escritorio, o de achicar la ventana
// del navegador de escritorio) el worker local fallaba con
// "Setting up fake worker failed... WorkerMessageHandler" — típico de un
// problema de red/compatibilidad al servir el worker desde nuestro propio
// servidor. El CDN es lo que recomienda la propia librería react-pdf.
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

// Nuestro servidor no soporta HTTP Range requests (streamea el archivo
// completo con fs.createReadStream), y pdf.js por defecto intenta usarlas
// para cargar el documento por partes — hay que desactivarlo explícitamente
// para que pida el PDF completo de una sola vez, igual que hacía el iframe.
// Objeto fuera del componente para que la referencia sea estable (si no,
// react-pdf remonta el <Document> en cada render).
const PDF_OPTIONS = { disableStream: true, disableRange: true, disableAutoFetch: true };

// Visor propio (pdf.js sobre <canvas>) en vez de <iframe src=pdf>.
// Necesario para navegador móvil: Chrome/Safari en celular reemplazan
// la app entera por su visor nativo al poner un PDF en un iframe.
export default function PdfViewer({ src }) {
  const [numPages, setNumPages] = useState(null);
  const [failed, setFailed] = useState(false);
  const [width, setWidth] = useState(600);
  const containerRef = useRef(null);
  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const update = () => setWidth(Math.max(240, Math.min(el.clientWidth - 24, 900)));
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  useEffect(() => {
    setNumPages(null);
    setFailed(false);
  }, [src]);

  if (failed) {
    return (
      <div className="pdf-viewer-msg" style={{ padding: 20, textAlign: 'center' }}>
        No se pudo cargar el documento.
        <br /><br />
        <span style={{ fontSize: 11, opacity: 0.7, wordBreak: 'break-word' }}>{failed}</span>
      </div>
    );
  }

  return (
    <div ref={containerRef} className="pdf-viewer-scroll">
      <Document
        file={src}
        options={PDF_OPTIONS}
        onLoadSuccess={({ numPages }) => setNumPages(numPages)}
        onLoadError={(err) => { console.error('PdfViewer: fallo al cargar el PDF', err); setFailed(String(err?.message || err)); }}
        loading={<div className="pdf-viewer-msg">Cargando documento...</div>}
      >
        {Array.from({ length: numPages || 0 }, (_, i) => (
          <Page
            key={i}
            pageNumber={i + 1}
            width={width}
            renderAnnotationLayer={false}
            renderTextLayer={false}
            loading=""
            className="pdf-viewer-page"
          />
        ))}
      </Document>
    </div>
  );
}
